/**
 * api.js — REST API client (firestore.js'in yerini alır)
 */

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

async function apiFetch(path) {
  const res = await fetch(`${API_URL}${path}`);
  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(body.error || `API hatası: ${res.status}`);
  }
  return res.json();
}

const memo = new Map();

function memoFetch(path) {
  if (!memo.has(path)) {
    const promise = apiFetch(path);
    memo.set(path, promise);
    promise.catch(() => {
      if (memo.get(path) === promise) memo.delete(path);
    });
  }
  return memo.get(path);
}

// Kategorileri order_num'a göre getir
export const fetchCategories = async () => {
  const categories = await memoFetch('/api/categories');
  return [...categories];
};

// Sadece aktif kategorileri getir
export const fetchActiveCategories = async () => {
  const categories = await memoFetch('/api/categories');
  return categories
    .filter((cat) => cat.is_active !== false)
    .sort((a, b) => (a.order_num ?? 0) - (b.order_num ?? 0));
};

// Tek kategori getir
export const fetchCategoryById = async (categoryId) => {
  try {
    return await apiFetch(`/api/categories/${categoryId}`);
  } catch {
    return null;
  }
};

// Bir kategorideki videoları getir
export const fetchProjectsByCategory = async (categoryId) => {
  const videos = await apiFetch(`/api/videos?category=${categoryId}`);
  return videos.sort((a, b) => (a.order_num ?? 0) - (b.order_num ?? 0));
};

// Her kategorinin ilk videosunu getir (anasayfa)
export const fetchTopVideos = async () => {
  const videos = await memoFetch('/api/videos/top');
  return [...videos];
};
